export const ModalWidth = "60%"